var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Typography from 'material-ui/Typography';
var LabeledInput = /** @class */ (function (_super) {
    __extends(LabeledInput, _super);
    function LabeledInput(props) {
        return _super.call(this, props) || this;
    }
    LabeledInput.prototype.render = function () {
        return (React.createElement("div", { style: { marginBottom: 0 } },
            React.createElement("div", { style: { width: 200, display: 'inline-block' } },
                React.createElement(Typography, { variant: "body1" }, this.props.label)),
            this.props.children));
    };
    return LabeledInput;
}(React.Component));
export { LabeledInput };



//////////////////
// WEBPACK FOOTER
// ./src/components/LabeledInput.tsx
// module id = 1697
// module chunks = 0